import { getHelpFAQPayload } from "src/config/posthog";
import type { FAQPayload } from "./types";

const bundles = import.meta.glob<{ default: FAQPayload }>(
  "../../assets/help-faq/*.json",
  { eager: true },
);

const bundleByProduct: Record<string, FAQPayload> = {};
for (const [path, mod] of Object.entries(bundles)) {
  const match = path.match(/help-faq\/([^/]+)\.json$/);
  if (!match || match[1] === "index") continue;
  bundleByProduct[match[1]] = mod.default;
}

/**
 * Load FAQ content for a product. Tries PostHog flag payload first, falls back
 * to the bundled JSON from the export script (airgapped fallback).
 */
export const loadFAQ = (product: string): FAQPayload | null => {
  const remote = getHelpFAQPayload(product) as FAQPayload | null;
  if (remote && Array.isArray(remote.sections)) return remote;
  return bundleByProduct[product] ?? bundleByProduct.platform ?? null;
};

/**
 * Bundled JSON only, ignoring any PostHog flag payload. For consumers that
 * must not lose content to a stale remote payload (e.g. inline config help).
 */
export const loadBundledFAQ = (product: string): FAQPayload | null =>
  bundleByProduct[product] ?? null;
